import React, { useState } from 'react'
import { ZoneStyles as styles } from "./chat.tailwind";
import SportCourt from '../../../../../Sports/SportCourt';
import { connect, useSelector } from 'react-redux';
import { getSportCourt } from '../../../../../../pages/SportPage/sportPageData';
import ZoneActivityTable from './ZoneActivityTable';
import { getGameActionsListCorrespondingToZone } from '../../../../../../redux/slices/liveGameSlice';
import { getZoneName } from '../../../../../../lib/utils/sportCourtConfigs';
import { ChevronLeft } from '@mui/icons-material';

const Zones = ({ gameId, getGameZoneDetails }) => {
  const { currentSeason } = useSelector(state => state.seasons);
  const checkSportGround = getSportCourt(currentSeason?.seasonCode);
  const ZonesName = currentSeason?.zoneCategories?.flatMap((zone) => {
    return zone.zones
  });

  const [activeZone, setActiveZone] = useState('');
  const [selectedZones, setSelectedZones] = useState([]);

  const fetchZoneDetails = (zone) => {
    const data = {
      gameId: gameId,
      zone
    }

    getGameZoneDetails(data);
  }

  const selectZone = (_zone) => {
    setSelectedZones([_zone]);
    const zone = getZoneName(_zone, currentSeason?.zoneCategories, currentSeason?.seasonCode);
    fetchZoneDetails(zone);
  }

  const handleClickZoneButton = (zone, index) => {
    setActiveZone(index);
    fetchZoneDetails(zone);
  }  
  
  return (
    <div className={styles.container}>
      <h1 className='text-[14px] font-[300] p-1 screen-500:hidden'>Zones</h1>
      <div className='hidden screen-500:block'>
        <SportCourt
          disableModal={true}
          previewGame={true}
          showHoveredTooltip={false}
          tokensToShowOnGround={[]}
          CourtGround={checkSportGround}
          isLiveGame={true}
          hideHover={false}
          disableTokenHover={true}
          makeSelectable={true}
          hideZoneName={false}
          selectZone={selectZone}
          selectedZones={selectedZones}
          courtOuterSvgId={"svg-holder-zones"}
        />
      </div>

      {activeZone && (
        <div className='w-full flex items-center justify-between'>
          <button className={`${styles.goBackBtn}`} onClick={() => setActiveZone('')}>
            <ChevronLeft fontSize='small' />
            Go Back
          </button>

          {ZonesName[Number(activeZone)]?.zoneName && (
            <p className={`${styles.zoneButton} ${styles.activeZoneButton}`}>
              {ZonesName[Number(activeZone)]?.zoneName}
            </p>
          )}
        </div>
      )}
      
      {!activeZone && (
        <div className={styles.zonesWrapper}>
          {ZonesName?.map((zone, index) => (
            <button
              className={`${activeZone === index?.toString() ? styles.activeZoneButton : ''} ${styles.zoneButton}`}
              key={index}
              onClick={() => handleClickZoneButton(zone?.zoneName, index?.toString())}
              disabled={index?.toString() === activeZone}
            >
              {zone?.zoneName}
            </button>
          ))}
        </div>
      )}

      {/* Zones Table */}
      {((selectedZones && selectedZones?.length > 0) || activeZone) && (
        <ZoneActivityTable />
      )}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getGameZoneDetails: (data) => dispatch(getGameActionsListCorrespondingToZone(data)),
});

export default connect(null, mapDispatchToProps)(Zones);